import { render, staticRenderFns } from "./lowHealth.vue?vue&type=template&id=3bc36d99&scoped=true"
import script from "./lowHealth.vue?vue&type=script&lang=js"
export * from "./lowHealth.vue?vue&type=script&lang=js"
import style0 from "./lowHealth.vue?vue&type=style&index=0&id=3bc36d99&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bc36d99",
  null
  
)

export default component.exports